import { useDispatch, useMachineState } from '../app/context';
import { Button } from '../components/Button';
import { cx } from '../components/cx';
import { bedKey, bedNumber, formatDuration, targetLabel } from '../domain/format';
import styles from './BedScreen.module.css';
import common from './common.module.css';

export function BedScreen() {
  const { ward, bed: selectedBed, sanitisedBeds, cycleTotal } = useMachineState();
  const dispatch = useDispatch();
  if (!ward) return null;

  const beds = Array.from({ length: ward.beds }, (_, i) => bedNumber(i));

  return (
    <section
      className={cx(common.screen, common.fadeUp, styles.screen)}
      aria-labelledby="bed-title"
    >
      <div className={cx(common.header, styles.header)}>
        <h2 id="bed-title" className={common.title}>
          {ward.name.toUpperCase()} — Select Bed Unit
        </h2>
        <Button variant="ghost" size="xs" onClick={() => dispatch({ type: 'BACK_TO_WARDS' })}>
          ← WARD SELECT
        </Button>
      </div>

      <div className={styles.grid}>
        {beds.map((bed) => {
          const sanitised = sanitisedBeds.includes(bedKey(ward.code, bed));
          const selected = bed === selectedBed;
          return (
            <button
              key={bed}
              type="button"
              className={cx(common.tile, styles.bed, sanitised && styles.sanitised)}
              aria-pressed={selected}
              aria-label={`Bed ${bed}${sanitised ? ', sanitised' : ''}`}
              onClick={() => dispatch({ type: 'SELECT_BED', bed })}
            >
              <span className={styles.number}>{bed}</span>
              <span className={styles.tag}>
                {sanitised ? 'SANITISED' : selected ? 'SELECTED' : 'PENDING'}
              </span>
            </button>
          );
        })}
      </div>

      {selectedBed && (
        <div className={common.actionBar}>
          <div className={common.actionTitle}>
            {targetLabel(ward.code, selectedBed)} · CYCLE {formatDuration(cycleTotal)}
          </div>
          <Button variant="primary" size="xl" onClick={() => dispatch({ type: 'CONFIRM_BED' })}>
            NEXT →
          </Button>
        </div>
      )}
    </section>
  );
}
